export default "__VITE_ASSET__Cyi_aj8t__"